RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EditHistory = Marionette.CompositeView.extend({
        template: '#adminCompanyEditHistoryTemplate',
        childView: views.EditHistoryItem,
        childViewContainer: 'tbody'
    });
});
